export default __webpack_public_path__ + "static/media/08.fd1c795a.jpg";